import React from "react";

/**
 * Shared loading skeletons with a subtle shimmer (see .st-skeleton in index.css).
 * Used to avoid the flash of empty-state messages before data resolves (Update 07).
 */

export function SkeletonBar({ className = "", style }) {
  return <div className={`st-skeleton ${className}`} style={style} aria-hidden="true" />;
}

// Skeleton <tr> rows for table bodies. Render inside a <tbody>.
export function SkeletonRows({ cols = 5, rows = 5 }) {
  return Array.from({ length: rows }).map((_, r) => (
    <tr key={r} className="border-t border-[#1a1a1a]" data-testid="skeleton-row">
      {Array.from({ length: cols }).map((_, c) => (
        <td key={c} className="px-4 py-3">
          <SkeletonBar className="h-3.5" style={{ width: c === 0 ? "60%" : "80%" }} />
        </td>
      ))}
    </tr>
  ));
}

// Skeleton for card-style list rows (e.g. Open Days / Tickets slot list).
export function CardListSkeleton({ rows = 4, testid = "list-skeleton" }) {
  return (
    <div className="space-y-2" data-testid={testid}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="st-card p-4" data-testid="skeleton-card">
          <div className="flex items-center gap-4">
            <SkeletonBar className="h-4" style={{ width: 160 }} />
            <SkeletonBar className="h-5" style={{ width: 72 }} />
            <SkeletonBar className="h-4 ml-auto" style={{ width: 96 }} />
          </div>
          <SkeletonBar className="h-1.5 mt-3" style={{ width: "100%" }} />
        </div>
      ))}
    </div>
  );
}
